import { connect } from 'react-redux'
import AddSchool from './add-school'
import { clearState } from '../redux/fsu-teacher.actions'

const mapDispatchToProps = dispatch => ({
  clearState: () => dispatch(clearState())
})

export default connect(
  null,
  mapDispatchToProps
)(AddSchool)
